const getTranslation = (literal: string, t: (item: string, options?: object) => string): string => {
    let translation = "";

    switch (literal) {
        case "Breakfast":
            translation = t("Breakfast", { ns: "recipe" });
            break;
        case "course":
            translation = t("Course", { ns: "recipe" });
            break;
        case "dietary_wishes":
            translation = t("Dietary wishes", { ns: "recipe" });
            break;
        case "difficulty":
            translation = t("Level of complexity", { ns: "recipe" });
            break;
        case "Cocktails & Drinks":
            translation = t("Cocktails & Drinks", { ns: "recipe" });
            break;
        case "Dessert":
            translation = t("Dessert", { ns: "recipe" });
            break;
        case "Dinner":
            translation = t("Dinner", { ns: "recipe" });
            break;
        case "Hard":
            translation = t("Hard", { ns: "recipe" });
            break;
        case "Healthy Snack":
            translation = t("Healthy Snack", { ns: "recipe" });
            break;
        case "Main Course 1":
            translation = t("Main Course 1", { ns: "recipe" });
            break;
        case "Main Course 2":
            translation = t("Main Course 2", { ns: "recipe" });
            break;
        case "Side":
            translation = t("Side", { ns: "recipe" });
            break;
        case "Soup":
            translation = t("Soup", { ns: "recipe" });
            break;
        case "Salad":
            translation = t("Salad", { ns: "recipe" });
            break;
        case "Starter":
            translation = t("Starter", { ns: "recipe" });
            break;
        case "Alcohol Free":
            translation = t("Alcohol Free", { ns: "recipe" });
            break;
        case "Eggs Free":
            translation = t("Eggs Free", { ns: "recipe" });
            break;
        case "Gluten Free":
            translation = t("Gluten Free", { ns: "recipe" });
            break;
        case "Lactose Free":
            translation = t("Lactose Free", { ns: "recipe" });
            break;
        case "Low Carb":
            translation = t("Low Carb", { ns: "recipe" });
            break;
        case "Low Fat":
            translation = t("Low Fat", { ns: "recipe" });
            break;
        case "Diabetic":
            translation = t("Diabetic", { ns: "recipe" });
            break;
        case "Vegan":
            translation = t("Vegan", { ns: "recipe" });
            break;
        case "Vegetarian":
            translation = t("Vegetarian", { ns: "recipe" });
            break;
        case "Average":
            translation = t("Average", { ns: "recipe" });
            break;
        case "Easy":
            translation = t("Easy", { ns: "recipe" });
            break;
        case "tsp":
            translation = t("tsp", { ns: "recipe" });
            break;
        case "tbsp":
            translation = t("tbsp", { ns: "recipe" });
            break;
        default:
            translation = literal;
    }

    return translation;
};

export default getTranslation;
